import React, { useEffect, useState } from "react";
import { InputAdornment } from "@mui/material";
import { connect } from "react-redux";
import { Mandatory } from "../../FormHelpers";
import CachedImage from "../../../../common/CachedImage";
import { CssTextField } from "./Styled";
import { ImagePath } from "../../../../../assets/ImagePath";


const BasicPhoneNumberField = (props) => {
    const {
        id,
        info,
        readOnly,
        value,
        handleChange,
        mandatory,
        onBlurField,
        placeholder,
        maxLength = 500,
        minLength,
        validation,
        isSections,
        validationResult,
        validationMessage,
        type,
        isSmallScreen,
        title,
        islabelvisible,
        emailAddress,
        balance,
        isPostPaidUser,
    } = props;

    // const [isInfoVisible, setInfoVisible] = useState(false);
    const [inputValue, setInputValue] = useState(value);
    const [inputObject, setObject] = useState(null);
    const [shrinkBoolean, setShrinkBoolean] = useState({ shrink: true });
    const [openDialPad, setOpenDialPad] = useState(false)
    const [currentPhoneNum, setCurrentPhoneNum] = useState("")

    useEffect(() => {

        if (inputValue !== value) {
            setInputValue(value);
        }
        if (value || value >= 0) {
            setShrinkBoolean({ shrink: true });
        } else setShrinkBoolean({ shrink: false });
    }, [value]);

    const handleBlur = (e) => {
        onBlurField(e);
    };

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            handleChange(inputObject);
        }, 400);

        return () => clearTimeout(delayDebounceFn);
    }, [inputObject]);

    const onValueChange = (e) => {
        handleChange(e);
    };

    const isBoolean = (val) => "boolean" === typeof val;

    const isError =
        validation && isBoolean(validationResult) ? !validationResult : false;

    const helperText =
        isBoolean(validationResult) && !validationResult ? validationMessage : info;

    const showCreateConversation = (phoneNumber) => {
        setOpenDialPad(true);
        phoneNumber = phoneNumber.replace(/ /g, "");
        setCurrentPhoneNum(phoneNumber);
    };

    const closeCreateConversation = () => {
        setOpenDialPad(false);
    };

    const makePhoneCall = async (phone, callMode) => {
        // if (R.isNil(phone)) {
        //     // notifyInvalidPhone()
        //     return
        // }

        if (!isPostPaidUser.isPostPaidUser) {
            if (balance <= 0) {
                closeCreateConversation()
                return;
            }
        }
        // if (callMode === "sat") {
        //     makeCall("sat", emailAddress, phone, phone, null, null, "on-call");
        // } else {
        //     makeCall("phone", emailAddress, phone, phone, null, null, "on-call");
        // }
    }

    return islabelvisible ? (
        <div className="relative flex items-start gap-1 update-input">
            <span className="min-w-[17px] min-h-[17px] rounded-7 flex items-center justify-center">
                <CachedImage
                    image={ImagePath.textField}
                    imgKey="date-picker-Icon2"
                    className="w-[17px] h-[17px]"
                />
            </span>
            <CssTextField
                id={id}
                name={id}
                type="text"
                size="small"
                fullWidth
                // label={isSmallScreen || isSections === true ? title : null}
                label={!islabelvisible ? <><Mandatory mandatory={mandatory} />{title}</> : null}
                variant="outlined"
                disabled={readOnly}
                value={inputValue}
                onChange={(e) => {
                    setObject(e);
                    setInputValue(e.target.value);
                }}
                placeholder={placeholder}
                onBlur={handleBlur}
                InputLabelProps={
                    value && {
                        shrink: true,
                    }
                }
                inputProps={{
                    maxLength,
                    minLength,
                    endAdornment: isError && (
                        <InputAdornment position="end">
                            <CachedImage
                                imgKey="warningIcon"
                                image="/images/warning@2x.png"
                                width="12px"
                            />
                        </InputAdornment>
                    ),
                }}
                helperText={!props.inline && helperText}
                error={isError}
            />
        </div>
    ) : (
        <>
        <div className="w-full">
            <div className="relative flex items-start gap-1 update-input mb-[5px]">
                <span className="min-w-[17px] min-h-[17px] rounded-7 flex items-center justify-center gap-1">
                    <CachedImage
                        image={ImagePath.textField}
                        imgKey="date-picker-Icon2"
                        className="w-[17px] h-[17px]"
                    />
                    <label class="text-size-14 text-[#15194B] font-regular mt-[2px]">{title}<Mandatory mandatory={mandatory} /></label>
                </span>
            </div>

                <CssTextField
                    id={id}
                    name={id}
                    type="text"
                    size="small"
                    fullWidth
                    // label={!islabelvisible ? <>{title}</> : null}
                    variant="outlined"
                    disabled={readOnly}
                    value={value}
                    onClick={() => {
                        readOnly && showCreateConversation(value)
                    }}
                    onChange={onValueChange}
                    placeholder={placeholder}
                    onBlur={handleBlur}
                    InputLabelProps={shrinkBoolean}

                    inputProps={{
                        maxLength,
                        minLength,
                        endAdornment: isError && (
                            <InputAdornment position="end">
                                <CachedImage
                                    imgKey="warningIcon"
                                    image="/images/warning@2x.png"
                                    width="12px"
                                />
                            </InputAdornment>
                        ),
                    }}
                    helperText={!props.inline && helperText}
                    error={isError}
                />
                </div>
            {/* {openDialPad && (
                <ModalPopup size="sm" noHeader className="dialler-modal">
                    <DiallerKeyPad
                        makePhoneCall={makePhoneCall}
                        onClose={closeCreateConversation}
                        // noBalance={() => props.noBalance()}
                        phoneNumFromLink={currentPhoneNum}
                    />
                </ModalPopup>
            )} */}
        </>
    );
};

export default BasicPhoneNumberField
